import React, { useEffect, useState } from "react";
import Filter from "../../../components/ui/Filter";
import { Button } from "../../../components/ui/button";
import {
  useAddMealItemMutation,
  useUpdateMealItemMutation,
} from "../../../featureSlice/mealItemSliceApi";

const MealItemFilter = ({ close, editData = null }) => {
  const [formData, setFormData] = useState({
    meal_item_id: "",
    meal_item_name: "",
    meal_item_is_veg: true,
    meal_item_status: true,
  });

  const [addMealItem, { isLoading: isAdding }] = useAddMealItemMutation();
  const [updateMealItem, { isLoading: isUpdating }] =
    useUpdateMealItemMutation();

  useEffect(() => {
    if (editData) {
      setFormData({
        meal_item_id: editData.meal_item_id || "",
        meal_item_name: editData.meal_item_name || "",
        meal_item_is_veg: editData.meal_item_is_veg ?? true,
        meal_item_status: editData.meal_item_status ?? true,
      });
    }
  }, [editData]);

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = async () => {
    try {
      if (editData) {
        await updateMealItem({
          
        uid: editData._id || editData.id || editData.meal_item_id,
        ...formData,
        }).unwrap();
        // console.log("Updated Successfully");
      } else {
        await addMealItem(formData).unwrap();
        // console.log("Added Successfully");
      }
      close();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleCancel = () => {
    setFormData({
      meal_item_id: "",
      meal_item_name: "",
      meal_item_is_veg: true,
      meal_item_status: true,
    });
  };
  useEffect(() => {
  console.log("editData received in filter:", editData);
}, [editData]);

  return (
    <div className="bg-white p-4 rounded-lg shadow space-y-4  absolute top-52 mt-4 right-7 w-96 text-darkGray font-medium">
      <button
        className="float-end text-xl cursor-pointer bg-white hover:bg-transparent pb-4" 
        onClick={close}
      >
        X
      </button>
      <Filter
        type="input"
        label="Meal Item Name"
        name="meal_item_name"
        value={formData.meal_item_name}
        onChange={handleChange}
        className="mt-4"
      />

      <div className="mb-4">
        <label className="block mb-1 font-medium">Category</label>
        <div className="flex gap-2">
          {["Veg", "Non-Veg"].map((category) => (
            <button
              key={category}
              type="button"
              onClick={() =>
                handleChange("meal_item_is_veg", category === "Veg")
              }
              className={`px-4 py-1 rounded-full font-medium ${
                (formData.meal_item_is_veg && category === "Veg") ||
                (!formData.meal_item_is_veg && category === "Non-Veg")
                  ? category === "Veg"
                    ? "bg-green-100 text-green-600 border border-green-500"
                    : "bg-red-100 text-red-600 border border-red-500"
                  : "bg-gray-100 text-gray-500"
              }`}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      <Filter
        type="switch"
        label="Status"
        name="meal_item_status"
        value={formData.meal_item_status}
        onChange={handleChange}
      />

      <div className="flex justify-between gap-4 pt-4">
        <Button variant="outline" onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          className="bg-primary text-white"
          disabled={isAdding || isUpdating}
        >
          {" "}
          {isAdding || isUpdating ? "Saving..." : "Submit"}
        </Button>
      </div>
    </div>
  );
};

export default MealItemFilter;
